import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  reload,
  updateFilterForCRM,
  loadPage,
  reset as resetPage,
} from "./PatientsSlice";
import { useParams, useLocation } from "react-router-dom";
import { useUserBranches } from "../../hooks/accessControl";
import { Modal, Dropdown, Button, Menu } from "antd";
import ActionsTable from "../../components/templates/ActionsTable";
import Phone from "../../components/tables/Phone";
import FullName from "../../components/tables/FullName";
import Address from "../../components/tables/Address";
import PatientBranch from "../../components/tables/PatientBranch";
import Age from "../../components/tables/Age";
import Gender from "../../components/tables/Gender";
import AvatarComponent from "../../components/tables/AvatarComponent";
import NewPatientWizard from "./newPatient/NewPatientWizard";
import NewCrmPatientWizard from "./newPatient/NewCrmPatientWizard";
import PatientCard from "./patientCard";
import PatientStatus from "../../components/tables/PatientStatus";
import Surface from "../../components/layouts/Surface";
import AnimationChildWrapper from "../../components/animations/AnimationChildWrapper";
import CheckBoxItem from "../../components/forms/CheckBoxItem";
import HistoryModal from "./scheduling/HistoryModal";
import { ReactComponent as PatientsImg } from "../../assets/no-patients.svg";
import {
  SearchOutlined,
  ScheduleOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { loadRecord, reset } from "../patientDetails/patientDetailsSlice";
import Approval from "./components/Approval";
import TransferPatient from "./components/TransferPatient";
import UploadEmergencyFile from "./components/UploadEmergencyFile";
import EmergencyFailedRowsModal from "./components/EmergencyFailedRowsModal";
import ExportEmergencyModal from "./components/ExportEmergencyModal";
import HouseVisitsReportModal from "./components/HouseVisitsReportModal";
import { usePermission } from "../../hooks/accessControl";
import { isAllowedFeature } from "../organization/organizationSlice";
import PrintFormsModal from "../../components/companyforms/PrintFormsModal";
import Header from "./components/Header";
const PatientsList = () => {
  const dispatch = useDispatch();
  const organizationDetails = useSelector(
    (state) => state.organization.details
  );
  const allowedFeatures =
    organizationDetails.features &&
    organizationDetails.features.map((i) => i.name);
  const crmIsAllowed = allowedFeatures?.includes("crm");

  const [visible, setVisible] = useState(false);
  const [patientCardVisible, setPatientCardVisible] = useState(false);
  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [transferPatientVisible, setTransferPatientVisible] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showScheduling, setShowScheduling] = useState(false);
  const [approvalModalVisible, setApprovalModalVisible] = useState(false);
  const [uploadVisible, setUploadVisible] = useState(false);
  const [exportEmergencyVisible, setExportEmergencyVisible] = useState(false);
  const [failedRows, setFailedRows] = useState([]);
  const [btlExcelHeaders, setBtlExcelHeaders] = useState([]);
  const [formsModalPatient, setFormsModalPatient] = useState(null);

  const userBranches = useUserBranches();
  const { page: patientsPage } = useSelector((state) => state.patients);
  const { current, pageSize, total, items, filter, order, staffInCharge } =
    patientsPage;
  const loading = useSelector(
    (state) => state.pendingActions["patients/loadPage"]
  );

  let { branchId } = useParams();

  let location = useLocation();
  const intl = useIntl();

  const [houseVisitsReportModalVisible, setHouseVisitsReportModalVisible] =
    useState(false);

  useEffect(() => {
    if (organizationDetails?.features) {
      dispatch(updateFilterForCRM(crmIsAllowed));
      dispatch(reload());
    }
  }, [branchId, crmIsAllowed, dispatch, organizationDetails?.features]);

  useEffect(() => {
    dispatch(
      loadPage({
        current: 1,
        filter,
        order,
        pageSize,
        staffInCharge,
      })
    );
  }, [staffInCharge]);

  const onTextChange = (e) => {
    dispatch(
      loadPage({
        current: 1,
        filter: { ...filter, freeText: e.target.value },
        order,
        pageSize,
        staffInCharge,
      })
    );
  };

  const onAddClick = () => {
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };

  const onShowPatientCardClicked = (record, show) => {
    setSelectedPatient(record);
    setPatientCardVisible(true);
    setShowScheduling(show);
    if (show) {
      getPatient(record.id);
    }
  };

  const onHidePatientCardModal = () => {
    setPatientCardVisible(false);
    dispatch(reset());
  };

  const onHideTransferPatient = () => {
    setTransferPatientVisible(false);
    dispatch(reset());
  };

  const onLaunchTransferPatient = (record) => {
    getPatient(record.id);
    setTransferPatientVisible(true);
  };

  const onlaunchApprovalModal = (record) => {
    setApprovalModalVisible(true);
    getPatient(record.id);
  };

  const hideApprovalModal = () => {
    setApprovalModalVisible(false);
  };

  const onLaunchHistoryModal = (record) => {
    getPatient(record.id);
    setHistoryModalVisible(true);
  };

  const onHideHistoryModal = () => {
    setHistoryModalVisible(false);
  };

  const onlaunchFormsModal = (record) => {
    setFormsModalPatient(record.id);
  };

  const onHideFormsModal = () => {
    setFormsModalPatient(null);
  };

  const getPatient = (id) => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      id: id,
      branchId: branchId,
      admin: isAdmin,
    };
    dispatch(loadRecord(params));
  };

  const handleExportEmergency = () => {
    setExportEmergencyVisible(true);
  };

  const hideExportEmergency = () => {
    setExportEmergencyVisible(false);
  };

  const changeFailedRows = (data, headers) => {
    setFailedRows(data);
    setBtlExcelHeaders(headers);
  };

  const onHideEmergencyFailedRowsModal = () => {
    setFailedRows([]);
    setBtlExcelHeaders([]);
  };

  const handleMenuClick = (e, record) => {
    switch (e.key) {
      case "1":
        onShowPatientCardClicked(record, true);
        break;
      case "2":
        onlaunchApprovalModal(record);
        break;
      case "3":
        onLaunchHistoryModal(record);
        break;
      case "4":
        onLaunchTransferPatient(record);
        break;
      case "5":
        onlaunchFormsModal(record);
        break;

      default:
        break;
    }
  };

  const hasTransferPatientPermission = usePermission(
    branchId,
    "patients",
    "transfer_branch"
  );
  const actionsDropDownMenuItems = [
    {
      label: intl.formatMessage({
        id: "app.patients.mainDetails",
      }),
      key: "1",
      icon: <SearchOutlined />,
    },

    {
      label: intl.formatMessage({
        id: "app.patients.approveScheduling",
      }),
      key: "2",
      icon: <ScheduleOutlined />,
    },

    {
      label: intl.formatMessage({
        id: "app.patients.showSchedulingHistory",
      }),
      key: "3",
      icon: <ScheduleOutlined />,
    },
    ...(hasTransferPatientPermission
      ? [
          {
            label: intl.formatMessage({
              id: "app.patients.transferPatient",
            }),
            key: "4",
            icon: <ScheduleOutlined />,
          },
        ]
      : []),
    ...[
      isAllowedFeature("forms") && {
        label: intl.formatMessage({
          id: "app.patients.print_forms",
        }),
        key: "5",
        icon: <ScheduleOutlined />,
      },
    ],
  ];

  const getActionsMenu = (record) => {
    const actionsDropDownMenu = {
      items: actionsDropDownMenuItems,
      onClick: (e) => handleMenuClick(e, record),
    };
    return actionsDropDownMenu;
  };

  const tableItems = [
    {
      title: "avatar_url",
      render: AvatarComponent,
      width: "80px",
    },
    {
      title: "fullname",
      sortIndex: "surename",
      sorter: true,
      render: FullName,
      width: "200px",
    },
    {
      title: "status_id",
      render: PatientStatus,
      width: "120px",
      filters: [
        { text: <FormattedMessage id="app.forms.active" />, value: 1 },
        {
          text: <FormattedMessage id="app.forms.not_active" />,
          value: 2,
        },
        ...(!crmIsAllowed
          ? [{ text: <FormattedMessage id="app.forms.candidate" />, value: 3 }]
          : []),
      ],
      responsive: ["xxl"],
    },
    {
      title: "local_id_number",
      responsive: ["xl"],
      width: "110px",
    },
    {
      title: "id",
      responsive: ["xxl"],
      width: "110px",
    },
    {
      title: "contact_info.mobile_number",
      responsive: ["md"],
      render: Phone,
      width: "140px",
      ellipsis: true,
    },
    {
      title: "contact_info.phone_number",
      responsive: ["xxl"],
      render: Phone,
      width: "140px",
      ellipsis: true,
    },
    {
      title: "age",
      responsive: ["lg"],
      render: Age,
      sortIndex: "birthday",
      sorter: true,
      columnProps: { field: "birthday" },
      width: "70px",
    },
    {
      title: "gender_id",
      responsive: ["xl"],
      render: Gender,
      width: "70px",
      filters: [
        {
          text: <FormattedMessage id="app.dataSelect.gender_id.male" />,
          value: 1,
        },
        {
          text: <FormattedMessage id="app.dataSelect.gender_id.female" />,
          value: 2,
        },
      ],
    },
    {
      title: "address",
      responsive: ["xl"],
      ellipsis: true,
      render: Address,
    },

    {
      title: "actions",
      responsive: ["md"],
      width: "120px",
      render: ({ record }) => {
        const menu = getActionsMenu(record);
        return (
          <div style={{ display: "flex" }}>
            <Dropdown trigger={["click"]} menu={menu}>
              <Button type="link">
                {intl.formatMessage({
                  id: "app.employees.options",
                })}
                <DownOutlined />
              </Button>
            </Dropdown>
          </div>
        );
      },
    },
  ];

  const isAdmin = location.pathname.includes("admin");
  if (isAdmin) {
    tableItems.splice(2, 0, {
      title: "branch_id",
      render: PatientBranch,
      width: "120px",
      responsive: ["lg"],
      filters: userBranches.map((i) => ({ text: i.name, value: i.id })),
    });
  }

  const handleUploadImmigrationFile = () => {
    setUploadVisible(true);
  };

  const hideUpload = () => {
    setUploadVisible(false);
  };

  const handleAdminPatientsMenuClick = (e) => {
    switch (e.key) {
      case "1":
        handleUploadImmigrationFile();
        break;

      default:
        break;
    }
  };

  const handleBranchPatientsMenuClick = (e) => {
    switch (e.key) {
      case "1":
        handleUploadImmigrationFile();
        break;
      case "2":
        handleExportEmergency();
        break;
      case "3":
        setHouseVisitsReportModalVisible(true);
        break;
      default:
        break;
    }
  };

  const adminDropDownMenuItems = [
    {
      label: intl.formatMessage({
        id: "app.patients.import_btl_emergency_excel",
      }),
      key: "1",
    },
  ];

  const branchDropDownMenuItems = [
    {
      label: intl.formatMessage({
        id: "app.patients.import_btl_emergency_excel",
      }),
      key: "1",
    },
    {
      label: intl.formatMessage({
        id: "app.patients.emergency_export",
      }),
      key: "2",
    },
    {
      label: intl.formatMessage({
        id: "app.patients.houseVisitsReport",
      }),
      key: "3",
    },
  ];

  const adminDropDownMenu = {
    items: adminDropDownMenuItems,
    onClick: (e) => handleAdminPatientsMenuClick(e),
  };

  const branchDropDownMenu = {
    items: branchDropDownMenuItems,
    onClick: (e) => handleBranchPatientsMenuClick(e),
  };

  const AdditionalItems = () => (
    <AnimationChildWrapper itemKey={3}>
      <CheckBoxItem showLabel={true} name="incremental" category="component" />
    </AnimationChildWrapper>
  );

  return (
    <Surface>
      <ActionsTable
        subHeaderComponent={<Header />}
        tableItems={tableItems}
        ltrItems={["contact_info.mobile_number"]}
        category={"patients"}
        resource="patients"
        filtersType={{ status_id: "number", gender_id: "number" }}
        current={current}
        pageSize={pageSize}
        total={total}
        order={order}
        loading={loading}
        textFilter={filter.freeText}
        reload={reload}
        loadPage={loadPage}
        skipInitialLoad={true}
        resetPage={resetPage}
        items={items}
        onTextChange={onTextChange}
        onAddClick={onAddClick}
        addbuttonText={<FormattedMessage id="app.patients.addNewPatient" />}
        headerInputPlaceholder={intl.formatMessage({
          id: "app.patients.typePatientName",
        })}
        dropDownMenu={branchId ? branchDropDownMenu : adminDropDownMenu}
        showheader={true}
        emptyImage={<PatientsImg />}
        emptytext={<FormattedMessage id="app.tables.noPatients" />}
        noTabs={true}
        autoFocus={true}
      />
      <Modal
        closable={false}
        maskClosable={false}
        footer={null}
        width={"1200px"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        title={null}
        open={visible}
        onCancel={hide}
        destroyOnClose={true}
      >
        {crmIsAllowed ? (
          <NewCrmPatientWizard
            hideWizard={hide}
            onShowPatientCardClicked={onShowPatientCardClicked}
          />
        ) : (
          <NewPatientWizard
            hideWizard={hide}
            onShowPatientCardClicked={onShowPatientCardClicked}
          />
        )}
      </Modal>
      <PatientCard
        record={selectedPatient}
        onHide={onHidePatientCardModal}
        visible={patientCardVisible}
        showScheduling={showScheduling}
      />
      <Approval
        approveVisible={approvalModalVisible}
        hideApprovalModal={hideApprovalModal}
      />
      <HistoryModal onHide={onHideHistoryModal} visible={historyModalVisible} />
      <TransferPatient
        visible={transferPatientVisible}
        hide={onHideTransferPatient}
        record={selectedPatient}
      />
      <UploadEmergencyFile
        visible={uploadVisible}
        hide={hideUpload}
        changeFailedRows={changeFailedRows}
        branchId={branchId}
      />
      <EmergencyFailedRowsModal
        hide={hideUpload}
        data={failedRows}
        headers={btlExcelHeaders}
        onDecline={onHideEmergencyFailedRowsModal}
      />
      <ExportEmergencyModal
        visible={exportEmergencyVisible}
        onHide={hideExportEmergency}
        branchId={branchId}
      />
      <HouseVisitsReportModal
        visible={houseVisitsReportModalVisible}
        onCancel={() => setHouseVisitsReportModalVisible(false)}
        branchId={branchId}
      />
      <PrintFormsModal
        visible={formsModalPatient}
        onCancel={onHideFormsModal}
        entityCollection="patients"
        entity="patient"
        entityId={formsModalPatient}
      />
    </Surface>
  );
};
export default PatientsList;
